<div class="account-opening-blocker">
  <app-ds-rounded-icon icon="loader" size="large" variant="info" color="var(--color-core-neutral-10)" />
  <h1 class="ds-title-1 header">{{ 'GROW.incompleteSetup.title' | translate }}</h1>
  <p class="ds-running-1">
    {{ 'GROW.incompleteSetup.description' | translate }}
  </p>
</div>

<div class="footer" hideGuarantee="true">
  <button class="ui-button" (click)="onClickCta()">
    {{ 'GROW.incompleteSetup.buttonLabel' | translate }}
  </button>
</div>
